export const formName = "autoAnnotate";
export const tabHeight = 34;
